// src/pages/AboutUs.jsx
import { useState } from "react";

export default function AboutUs() {
  const [showMore, setShowMore] = useState(false);

  return (
    <section
      id="about"
      className="py-16 bg-white scroll-mt-40"
      /* This scroll-mt offsets the fixed navbar when using #about links */
    >
      <div className="max-w-6xl mx-auto px-6 text-center">
        <h2 className="text-3xl font-bold text-gray-800 mb-4">About Us</h2>

        <p className="text-lg text-gray-700 max-w-3xl mx-auto mb-6">
          AllWell Companion Home Care was founded with one clear mission —
          <strong> to bring compassionate, high-quality, and reliable care </strong>
          to seniors and individuals with special needs, helping them live with dignity and
          independence in the comfort of their own homes.
        </p>

        <p className="text-lg text-gray-700 max-w-3xl mx-auto mb-6">
          We understand that every individual’s needs are unique. That’s why we go beyond
          basic assistance — offering <strong>personalized care plans, emotional support,</strong> and
          genuine companionship that enrich the daily lives of our clients.
        </p>

        {showMore && (
          <>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto mb-6">
              Our team is built on a foundation of trust, empathy, and professionalism. Every caregiver
              is carefully screened, trained, and committed to delivering care that not only meets
              physical needs but also nurtures emotional well-being.
            </p>

            <p className="text-lg text-gray-700 max-w-3xl mx-auto mb-6">
              At AllWell Companion Home Care, we believe home is where the heart is. Whether it’s
              helping with daily activities, providing a listening ear, or offering peace of mind to
              families, we are here to make every day safer, easier, and more meaningful for those we serve.
            </p>

            <div className="text-left max-w-2xl mx-auto mt-8">
              <h3 className="text-2xl font-semibold text-teal-700 mb-3">Our Promise:</h3>
              <ul className="list-disc list-inside text-lg text-gray-700 space-y-2">
                <li>To treat every client with <strong>respect and dignity</strong></li>
                <li>To provide <strong>dependable care</strong> families can trust</li>
                <li>To foster <strong>independence</strong> while ensuring safety and comfort</li>
                <li>To be a <strong>source of support</strong> and reassurance for loved ones</li>
              </ul>
            </div>

            <p className="text-xl font-semibold text-gray-800 mt-8">
              Because at AllWell Companion Home Care, we don’t just care for people — we care about people.
            </p>
          </>
        )}

        <div className="mt-10">
          <button
            onClick={() => setShowMore((v) => !v)}
            className="inline-block bg-teal-600 text-white font-semibold text-lg px-8 py-3 rounded-full shadow-md hover:bg-teal-700 hover:shadow-lg transition"
          >
            {showMore ? "Show Less" : "Learn More"}
          </button>
        </div>
      </div>
    </section>
  );
}
